import { createSelector } from "@reduxjs/toolkit";

import { isOnsiteUpsellBuilder } from "@src/store/slices/experienceBuilder/common/selectors/isOnsiteUpsellBuilder";
import {
  BUNDLE_FEATURED_IDEAS,
  BUNDLE_PDP_IDEA,
  FEATURED_IDEA_IDS,
  ONSITE_UPSELL_FEATURED_IDEAS,
} from "@src/store/slices/experienceBuilder/ideas/data";
import { ideasSlice } from "@src/store/slices/experienceBuilder/ideas/slice";
import type { Idea } from "@src/store/slices/experienceBuilder/ideas/types";
import { experienceBuilderSlice } from "@src/store/slices/experienceBuilder/slice";
import { getCanCreateBundleOnsiteUpsell } from "@src/store/slices/organization/selectors/getCanCreateBundleOnsiteUpsell";

const { getIdeas } = ideasSlice.selectors;

// Keyed off the builder mode, not `experience.type`, so a personalization opened
// as an upsell still gets the upsell chips.
export const getFeaturedIdeas = createSelector(
  [
    getIdeas,
    isOnsiteUpsellBuilder,
    experienceBuilderSlice.selectors.getInitialComponentType,
    getCanCreateBundleOnsiteUpsell,
  ],
  (ideas, isOnsiteUpsell, initialComponentType, canCreateBundle) => {
    if (initialComponentType === "bundleOnsiteUpsell") {
      return BUNDLE_FEATURED_IDEAS;
    }
    if (isOnsiteUpsell) {
      return canCreateBundle
        ? ONSITE_UPSELL_FEATURED_IDEAS
        : ONSITE_UPSELL_FEATURED_IDEAS.filter(
            (idea) => idea !== BUNDLE_PDP_IDEA
          );
    }
    const byId = new Map(ideas.map((idea) => [idea.id, idea]));
    return FEATURED_IDEA_IDS.map((id) => byId.get(id)).filter(
      (idea): idea is Idea => idea !== undefined
    );
  }
);
